import { InputNumber } from "primereact/inputnumber";
import React from "react";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import styled from "styled-components";
import COLORS from "utils/constants/COLORS";
import { getColorByIndex } from "utils/funciones";

const NewPlanesTBTA = ({
  planes,
  setValueInPlanes,
  minimoDias,
  maximoDias,
  onClickCalcular,
}) => {
  const { monedaSimbolo } = useSelector((state) => ({
    monedaSimbolo: state?.CatalogosMex?.setCatalogoBtaEmpresas?.monedaSimbolo || "",
  }));

  return (
    <div className='row'>
      {planes.map((plan, index) => (
        <React.Fragment key={plan.planCodigo}>
          <div className='col-md-6 col-lg-3' style={{ padding: "0.5rem" }}>
            <div className='card-planes-mex'>
              <div
                className='text-mex text-center mt-3 py2'
                style={{
                  backgroundColor: getColorByIndex(index),
                  fontSize: "20px",
                  paddingBottom: "0.5rem",
                  paddingTop: "0.5rem",
                  width: "100%",
                }}>
                {plan.planNombre}
              </div>

              <Controller
                name={plan.planCodigo}
                defaultValue={0}
                rules={{
                  validate: (value) => {
                    if (!value || value === "" || value === 0) {
                      setValueInPlanes(plan, value, false);
                      return true;
                    }
                    if (value < minimoDias) {
                      setValueInPlanes(plan, value, true);
                      return `El mínimo de dias es de ${minimoDias}`;
                    }

                    if (value > maximoDias) {
                      setValueInPlanes(plan, value, true);
                      return `Máximo de dias es de ${maximoDias}`;
                    }

                    setValueInPlanes(plan, value, true);
                    return true;
                  },
                }}
                render={({ value, onChange }) => (
                  <div className='d-flex flex-row mt-2'>
                    <DiasCotizar>
                      <label htmlFor={plan.planCodigo}>Días a cotizar</label>

                      <InputNumber
                        inputId={plan.planCodigo}
                        min={0}
                        max={20000}
                        mode='decimal'
                        value={+value}
                        onChange={({ value }) => {
                          return onChange(value);
                        }}
                      />
                    </DiasCotizar>
                    <CalcularPrima>
                      <button onClick={onClickCalcular}>Calcular prima</button>
                      <div className='container-prima'>
                        <h6 className='align-self-center'>
                          $ {plan.total} {monedaSimbolo}
                        </h6>
                      </div>
                    </CalcularPrima>
                  </div>
                )}
              />
              <div className='car-planes-coberturas' style={{ fontSize: "20px" }}>
                Coberturas
              </div>

              <div className='car-planes-detalles'>
                {plan?.coberturas?.map((cobertura, index) => (
                  <div className='row' key={index}>
                    <div className='col-6 col-lg-7'>{cobertura.cobNombre}</div>
                    <div className='col-6 col-lg-5'>
                      <div className='car-planes-detalles-bold'>
                        {`${cobertura.codLimite} ${monedaSimbolo}`}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default NewPlanesTBTA;

const DiasCotizar = styled.div`
  max-width: 40% !important;
  height: 65px;
  & > label {
    height: 30px;
    width: 95%;
    text-align: center;
    display: grid;
    justify-content: center;
    align-items: center;
  }

  & > span {
    max-width: 97% !important;
    padding: 0 0.5rem;
    & > input {
      text-align: center;
      border: 1.3px solid ${COLORS.primary} !important;
      max-width: 100% !important;
      border-radius: 0;
    }
  }
`;

const CalcularPrima = styled.div`
  width: 100% !important;
  height: 60px;
  button {
    height: 30px;
    background-color: ${COLORS.primary};
    border: none;
    color: white;
    width: 100%;
    cursor: pointer;
    &:hover {
      background-color: ${COLORS.cobalt};
    }
  }
  div.container-prima {
    width: 100%;
    border: 1px solid ${COLORS.primary};
    height: 45px;
    display: grid;
    justify-content: center;
    align-items: center;
  }
`;
